var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRaiseTicket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.001,
    height: 21.667,
    viewBox: "0 0 21.001 21.667",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.164,21H1.424A1.426,1.426,0,0,1,0,19.576V16.927a1.4,1.4,0,0,1,.887-1.3.746.746,0,0,0,0-1.391A1.4,1.4,0,0,1,0,12.936v-2.65A1.425,1.425,0,0,1,1.424,8.862h.859L10.728.417a1.426,1.426,0,0,1,2.014,0L14.615,2.29a1.4,1.4,0,0,1,.292,1.546.745.745,0,0,0,.685,1.046.735.735,0,0,0,.3-.063,1.364,1.364,0,0,1,.554-.116,1.415,1.415,0,0,1,.993.409l1.873,1.874a1.426,1.426,0,0,1,.121,1.876h.145A1.425,1.425,0,0,1,21,10.286v2.65c0,.022,0,.043,0,.065H19.753a.164.164,0,0,0,.013-.065v-2.65a.189.189,0,0,0-.189-.189h-2.9V13H15.442V10.1H1.424a.189.189,0,0,0-.188.189v2.65a.158.158,0,0,0,.1.149,1.981,1.981,0,0,1,0,3.695.158.158,0,0,0-.1.148v2.649a.189.189,0,0,0,.188.189H12.164V21ZM11.735,1.235a.187.187,0,0,0-.133.055L9.257,3.635l5.226,5.227H17.7l.736-.736a.189.189,0,0,0,0-.267L16.565,5.986a.164.164,0,0,0-.115-.048.144.144,0,0,0-.059.012,1.956,1.956,0,0,1-.794.166,1.978,1.978,0,0,1-1.818-2.779.158.158,0,0,0-.036-.174L11.868,1.29A.187.187,0,0,0,11.735,1.235ZM8.383,4.509h0L4.029,8.862h8.707L8.383,4.509Zm3.782,13.4H4.324V16.677h7.841v1.234Zm0-2.47H4.324V14.206h7.841V15.44Zm1.425-2.47H4.324V11.735h9.266V12.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M-950.284,8625.6h2.536v-2.555h1.511v2.555h2.529v1.538h-2.529v2.526h-1.511v-2.526h-2.536Z",
    transform: "translate(964.165 -8608)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRaiseTicket);
export default __webpack_public_path__ + "static/media/raiseTicket.a190e5e0.svg";
export { ForwardRef as ReactComponent };